import { Link } from "react-router-dom";
import { Star, Heart } from "lucide-react";
import { useState } from "react";
import { resolveImg, fmtRON } from "@/lib/api";

export function PropertyCard({ property, index = 0 }) {
  const [liked, setLiked] = useState(false);
  const [imgIdx, setImgIdx] = useState(0);
  const images = property.images?.length ? property.images : [""];

  return (
    <Link to={`/proprietate/${property.id}`} data-testid={`property-card-${property.id}`}
          className="group block animate-fade-up" style={{ animationDelay: `${Math.min(index * 60, 480)}ms` }}>
      <div className="card-hover rounded-2xl overflow-hidden bg-card border border-border/60">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img src={resolveImg(images[imgIdx])} alt={property.title}
               className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
          <button onClick={(e) => { e.preventDefault(); setLiked(!liked); }}
                  className="absolute top-3 right-3 h-8 w-8 rounded-full bg-black/25 backdrop-blur-sm flex items-center justify-center"
                  data-testid={`wishlist-${property.id}`}>
            <Heart className={`h-4 w-4 ${liked ? "fill-accent text-accent" : "text-white"}`} />
          </button>
          {property.is_superhost && (
            <span className="absolute top-3 left-3 bg-background/90 text-foreground text-xs font-semibold px-2.5 py-1 rounded-full">
              Superhost
            </span>
          )}
          {images.length > 1 && (
            <div className="absolute bottom-3 left-1/2 -translate-x-1/2 flex gap-1.5">
              {images.slice(0, 5).map((_, i) => (
                <button key={i} onClick={(e) => { e.preventDefault(); setImgIdx(i); }}
                        className={`h-1.5 rounded-full transition-all ${i === imgIdx ? "w-4 bg-white" : "w-1.5 bg-white/60"}`} />
              ))}
            </div>
          )}
        </div>
        <div className="p-4">
          <div className="flex items-start justify-between gap-2">
            <h3 className="font-medium text-[15px] leading-snug line-clamp-1">{property.title}</h3>
            <span className="flex items-center gap-1 text-sm shrink-0">
              <Star className="h-3.5 w-3.5 fill-[hsl(var(--amber))] text-[hsl(var(--amber))]" />
              {property.rating}
            </span>
          </div>
          <p className="text-sm text-muted-foreground mt-0.5 line-clamp-1">{property.location}</p>
          <p className="text-sm text-muted-foreground line-clamp-1">
            {property.bedrooms} dormitoare · {property.max_guests} oaspeți
          </p>
          <p className="mt-2 text-[15px]">
            <span className="font-semibold">{fmtRON(property.price_per_night)}</span>
            <span className="text-muted-foreground"> / noapte</span>
          </p>
        </div>
      </div>
    </Link>
  );
}
